<template>
  <div>
    <base-box @getList="getList" :total="total" :loading="loading" trackCode='tradeListPayment-1'>
      <template v-slot:mainTable="{height}">
        <el-table
          border
          row-class-name="table-row"
          header-row-class-name="table-header-cell"
          :data="list"
          v-loading="loading"
          :height="height"
          :key="height"
        >
          <el-table-column label="账单日期" prop="countingDate" min-width="120">
            <template slot-scope="{row}">
              <div>{{row.countingDate | formatTime('yyyy-MM-dd')}}</div>
            </template>
          </el-table-column>
          <el-table-column label="主体编号" prop="merchantNo" min-width="120" />
          <el-table-column label="对账主体名称" prop="merchantName" min-width="120" />
          <el-table-column label="未匹配数(元)" min-width="80" align="center">
            <template slot-scope="{row}">
              <div v-if="row.unmatchedAmount >= 0">{{row.unmatchedAmount | toFenThousandsAndFloat}}</div>
              <div v-else>-{{toFenThousands(Math.abs(row.unmatchedAmount))}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统代付总额(元)</div>
              <div>渠道代付总额(元)</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finAmount | toFenThousandsAndFloat}}</div>
              <div>{{row.thirdAmount | toFenThousandsAndFloat}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统代付总笔数</div>
              <div>渠道代付总笔数</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finCount || '0'}}</div>
              <div>{{row.thirdCount || '0'}}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" align="center">
            <template slot="header">
              <div>系统手续费总额(元)</div>
              <div>渠道手续费总额(元)</div>
            </template>
            <template slot-scope="{row}">
              <div>{{row.finFeeAmount | toFenThousandsAndFloat}}</div>
              <div>{{row.thirdFeeAmount | toFenThousandsAndFloat}}</div>
            </template>
          </el-table-column>
          <el-table-column label="对账所属渠道" prop="channelTypeDesc" min-width="80" />
          <el-table-column label="是否确认" prop="confirmStatusDesc" min-width="100" />
          <el-table-column label="操作" width="180">
            <template slot-scope="{row}">
              <div class="flex">
                <el-button
                  type="text" @click="handleDetail(row)" v-if="$has('FWS-DZZX-DZDF-XQ')"
                  v-track
                  trackCode='tradeListPayment-2'
                >查看明细</el-button>
                <page-export-button
                  v-if="$has('FWS-DZZX-DZDF-XZ')"
                  buttonText="下载"
                  buttonType="text"
                  exportType="button"
                  exportServe="fin_counting_tradePaymentReport"
                  :exportParams="{countingNo: row.countingNo}"
                  trackCode='tradeListPayment-3'
                />
              </div>
              <div class="flex" v-if="row.confirmStatus === 0">
                <el-button
                  type="text" @click="handleOperate(1, row)" v-if="$has('FWS-DZZX-DZDF-CXHQ')"
                  v-track
                  trackCode='tradeListPayment-4'
                >重新获取</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </base-box>

    <!-- 详情 -->
    <detail :visible.sync="isDetailShow" :countingNo="countingNo" />

    <!-- 操作 -->
    <jr-operate-dialog
      :visible.sync="isOperateShow"
      :text-config.sync="textConfig"
      :loading="opLoading"
      @submit="handleOperateSubmit"
    />

  </div>
</template>

<script>
import { getTradePayList } from '@/api/counting';
import baseBox from '../components/base-box';
import tradeOperateMixins from './mixins/operate';
import detail from './components/payment-detail';
import fileDownloadMixins from '@/mixins/file-download';
import { toFenThousandsAndFloat } from '@/filters/index';

export default {
  name: 'TradeListPayment',
  components: { baseBox, detail },
  data() {
    return {
      isDetailShow: false,
      loading: false,
      list: [],
      total: 0,
      countingNo: '',
      queryForm: {},
    };
  },
  mixins: [tradeOperateMixins, fileDownloadMixins],
  methods: {
    async getList(params = {}) {
      try {
        this.loading = true;
        const searchParams = { ...this.queryForm, ...params };
        this.queryForm = { ...searchParams };
        delete searchParams.timeType;
        const res = await getTradePayList(searchParams);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.list = [];
        console.log(error);
      }
    },
    // 查看详情
    handleDetail(row) {
      this.countingNo = row.countingNo;
      this.isDetailShow = true;
    },
    toFenThousands(num) {
      return toFenThousandsAndFloat(num);
    },
  },
};
</script>
